import React from 'react';
import theme from 'styles/theme';

interface SVGAttributeProps extends React.SVGAttributes<HTMLOrSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const KebabIcon = ({
  width = 24,
  height = 24,
  color = theme.black,
  ...rest
}: SVGAttributeProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      {...rest}
    >
      <path
        d='M12 16.5C12.5304 16.5 13.0391 16.7107 13.4142 17.0858C13.7893 17.4609 14 17.9696 14 18.5C14 19.0304 13.7893 19.5391 13.4142 19.9142C13.0391 20.2893 12.5304 20.5 12 20.5C11.4696 20.5 10.9609 20.2893 10.5858 19.9142C10.2107 19.5391 10 19.0304 10 18.5C10 17.9696 10.2107 17.4609 10.5858 17.0858C10.9609 16.7107 11.4696 16.5 12 16.5ZM12 10.5C12.5304 10.5 13.0391 10.7107 13.4142 11.0858C13.7893 11.4609 14 11.9696 14 12.5C14 13.0304 13.7893 13.5391 13.4142 13.9142C13.0391 14.2893 12.5304 14.5 12 14.5C11.4696 14.5 10.9609 14.2893 10.5858 13.9142C10.2107 13.5391 10 13.0304 10 12.5C10 11.9696 10.2107 11.4609 10.5858 11.0858C10.9609 10.7107 11.4696 10.5 12 10.5ZM12 4.5C12.5304 4.5 13.0391 4.71071 13.4142 5.08579C13.7893 5.46086 14 5.96957 14 6.5C14 7.03043 13.7893 7.53914 13.4142 7.91421C13.0391 8.28929 12.5304 8.5 12 8.5C11.4696 8.5 10.9609 8.28929 10.5858 7.91421C10.2107 7.53914 10 7.03043 10 6.5C10 5.96957 10.2107 5.46086 10.5858 5.08579C10.9609 4.71071 11.4696 4.5 12 4.5Z'
        fill={color}
      />
    </svg>
  );
};

export default KebabIcon;
